// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

console.log('VITE APPLICATION HOST: ', import.meta.env.VITE_APPLICATION_HOST)

console.log('VITE_ENVIRONMENT: ', import.meta.env.VITE_ENVIRONMENT)

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.glob('./**/*_channel.js', { eager: true })

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

/* eslint no-undef: 0 */
import Vue from 'vue/dist/vue.esm.js'
import { localize } from 'vee-validate'
import es from 'vee-validate/dist/locale/es.json'
import { camelizeKeys } from 'humps'
import VModal from 'vue-js-modal'
import ActionCableVue from 'actioncable-vue'
import VCalendar from 'v-calendar'
import { rutInputDirective } from 'vue-dni'
import VTooltip from 'v-tooltip'
import VueCurrencyInput from 'vue-currency-input'
import Clipboard from 'v-clipboard'
import 'bootstrap/dist/js/bootstrap.min.js'
import VueHtmlToPaper from 'vue-html-to-paper'
import { createPinia, PiniaVuePlugin } from 'pinia'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-bootstrap.css'

// Styles custom for toast notifications
import 'assets/styles/toast-notification.css'

// Tailwind compiled
import 'assets/styles/legacy-output.css'

// import Talanify Next
import 'talanify-next/dist/v2.7/index.css'
import 'assets/styles/tailwind.css'
import * as Talanify from 'talanify-next/dist/v2.7'

// import Vuetify
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import VueTour from 'vue-tour'
import '../assets/styles/app.scss'
import store from '../store'

// import Global Components
import Loader from '../components/ui/loader.vue'
import { TLoader } from 'talanify-next/dist/v2.7'
import EvaluationsConfig from '../components/company/evaluations-config/container.vue'
import MailingContainer from '../components/company/mailing/mailing-container.vue'
import CompanyStock from '../components/company/company-stock.vue'

// helpers
import interceptorsSetup from '../helpers/interceptors'
import '../helpers/validation-rules'

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes',
  ],
  styles: [
    'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
  ],
  timeout: 1000,
  autoClose: true,
  windowTitle: window.document.title,
}

Vue.use(VueHtmlToPaper, options)

// Register globally each Talanify-Next component
Object.values(Talanify).forEach(component => {
  if (component.hasOwnProperty('__name')) Vue.component(component.__name, component)
})

Vue.component('App', () => ({ component: import('App') }))

Vue.component('router-link', () => ({ component: import('components/ui/RouterLink.vue') }))

Vue.component('index-ks', () => ({
  component: import('../components/keyscoring/index/index.vue'),
  loading: Loader,
}))
Vue.component('index-ki', () => ({
  component: import('../components/keyinterview/index/index.vue'),
  loading: Loader,
}))
Vue.component('index-kj', () => ({
  component: import('../components/keyjobs/index/index.vue'),
  loading: Loader,
}))
Vue.component('index-kg', () => ({
  component: import('../components/keygaming/index/index.vue'),
  loading: Loader,
}))
Vue.component('index-kv', () => ({
  component: import('../components/keyvitae/index.vue'),
  loading: Loader,
}))
Vue.component('index-km', () => ({
  component: import('../components/keymailer/index/index.vue'),
  loading: Loader,
}))
Vue.component('process-board', () => ({
  component: import('../components/process-board.vue'),
  loading: Loader,
}))
Vue.component('flash-v2', () => import('../components/flash-v2/flash-v2.vue'))
Vue.component('process-form', () => ({
  component: import('../components/process-form/process-form.vue'),
  loading: Loader,
}))
Vue.component('new-applicant-button', () => import('../components/new-applicant-button.vue'))
Vue.component('discarded-applicants', () => import('../components/discarded-applicants.vue'))
Vue.component('k-table', () => import('../components/k-table.vue'))
Vue.component('k-paginator', () => import('../components/k-paginator.vue'))
Vue.component('users-index', () => ({
  component: import('../components/users-index.vue'),
  loading: Loader,
}))
Vue.component('Dashboard', () => ({
  component: import('modules/dashboard/views/DashboardView.vue'),
  loading: Loader,
}))
Vue.component('close-process', () => import('../components/close-process.vue'))
Vue.component('processes-list-view', () => import('modules/processes/views/ProcessesListView.vue'))
Vue.component('process-header', () => import('../components/process-header.vue'))
Vue.component('settings-ks', () => import('../components/keyscoring/settings_keyscoring/settings-ks.vue'))
Vue.component('custom-email-ks', () => import('../components/keyscoring/settings_keyscoring/custom-email-ks.vue'))
Vue.component('new-ks', () => import('../components/keyscoring/new_keyscoring/NewKs.vue'))
Vue.component('new-competence', () => import('../components/keyscoring/new_keyscoring/new-competence.vue'))
Vue.component('homologation-ks', () => import('../components/keyscoring/homologation_ks/homologationKs.vue'))
Vue.component('show-ks', () => import('../components/keyscoring/show/show.vue'))
Vue.component('test-homologation', () => import('../components/keyscoring/pages/test-homologation.vue'))
Vue.component('user-form', () => import('../components/user-form.vue'))
Vue.component('new-ki', () => import('../components/keyinterview/new/new-ki.vue'))
Vue.component('edit-kj', () => import('../components/keyjobs/edit/edit-kj.vue'))
Vue.component('kv-settings', () => ({
  component: import('../components/keyvitae/components/kv-settings.vue'),
  loading: Loader,
}))
Vue.component('index-kq', () => import('../components/keyquestion/index/index.vue'))
Vue.component('company-profile', () => ({
  component: import('../components/company-profile.vue'),
  loading: Loader,
}))
Vue.component('ApplicantDetailsModal', () => import('../components/applicant-details/ApplicantDetailsModal.vue'))
Vue.component('ApplicantsView', () => ({
  component: import('modules/applicants/views/ApplicantsView.vue'),
  loading: Loader,
}))
Vue.component('billing-container', () => import('../components/company/billing-container.vue'))
Vue.component('billing-completed', () => import('../components/company/billing-completed.vue'))
Vue.component('session-container', () => import('../components/login-process/session-container.vue'))
Vue.component('login-container', () => import('../components/login-process/login-container.vue'))
Vue.component('registration', () => import('../components/login-process/registration.vue'))
Vue.component('forgot-password', () => import('../components/login-process/forgot-password.vue'))
Vue.component('notification-icon', () => import('../components/notification-icon.vue'))
Vue.component('offer-wizard', () => import('../components/multiposting/wizard/OfferWizard.vue'))
Vue.component('process-wizard-view', () => import('modules/processes/views/ProcessWizardView.vue'))
Vue.component('design-container', () => import('../components/design/DesignView.vue'))
Vue.component('offer-diffusion', () => ({
  component: import('../components/company/diffusion/offer-diffusion.vue'),
  loading: Loader,
}))
Vue.component('menu-icon', () => import('../components/menu-icon.vue'))
Vue.component('edit-icon', () => import('../components/edit-icon.vue'))
Vue.component('evaluations-config', EvaluationsConfig)
Vue.component('mailing-container', MailingContainer)
Vue.component('company-stock', CompanyStock)
Vue.component('index-kf', () => ({
  component: import('../modules/keyform/views/list/KeyformListView.vue'),
  loading: Loader,
}))
Vue.component('new-kf', () => ({
  component: import('../modules/keyform/views/editor/KeyformEditorView.vue'),
  loading: Loader,
}))

Vue.component('keyform-preview', () => ({
  component: import('../modules/keyform/views/preview/KeyformPreviewView.vue'),
  loading: Loader,
}))

Vue.component('create-applicant-file', () => ({
  component: import('../modules/talanaIntegration/views/CreateApplicantFileView.vue'),
  loading: Loader,
}))

import 'vue-tour/dist/vue-tour.css'
import '@rails_assets/stylesheets/application.scss'

Vue.use(VModal, { dynamic: true, injectModalsContainer: true })
Vue.use(ActionCableVue, {
  debug: true,
  debugLevel: 'error',
  connectionUrl:
    import.meta.env.VITE_ENVIRONMENT === 'production' ?
      import.meta.env.VITE_APPLICATION_HOST.replace('https', 'wss') :
      'ws://localhost:3000/api/cable',
  connectImmediately: true,
})
Vue.use(VueToast, { position: 'top', duration: 4000, queue: true })
Vue.use(VCalendar, {
  componentPrefix: 'vc',
  color: 'purple',
})
Vue.use(VueTour)
Vue.use(VTooltip)
Vue.use(VueCurrencyInput)
Vue.use(Clipboard)
Vue.use(Vuetify)
Vue.use(PiniaVuePlugin)
Vue.filter('camelizeKeys', camelizeKeys)
Vue.directive('rut', rutInputDirective)

localize('es', es)

const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    themes: {
      light: {
        'haunter-purple': '#6344dd',
        'blue-superman': '#2222BF',
        'blue-lighter': '#E9F2F8',
        'blue-light': '#87C6F1',
        'blue-default': '#59A7DE',
        'blue-dark': '#2A7AB2',
        'green-lighter': '#F3FFC8',
        'green-light': '#D0F846',
        'green-default': '#B3DA2C',
        'green-dark': '#8CB00E',
        'yellow-lighter': '#FFEFB7',
        'yellow-light': '#FFE486',
        'yellow-default': '#FFD543',
        'yellow-dark': '#FFC700',
        'purple-lighter': '#F4B1FF',
        'purple-light': '#ED7CFF',
        'purple-default': '#E44BFD',
        'purple-dark': '#DB01FF',
        'red-lighter': '#FF223A',
        'red-light': '#E90019',
        'red-default': '#C50015',
        'red-dark': '#C6291C',
        'gray-lighter': '#F5F6F8',
        'gray-one': '#506083',
        'gray-light': '#CCD5DA',
        'gray-default': '#A5B6BE',
        'gray-dark': '#8B959A',
        'darkgray-lighter': '#AAC8D8',
        'darkgray-light': '#7098AC',
        'darkgray-default': '#486A7B',
        'darkgray-dark': '#263D49',
        'primary': '#6344dd',
        'secondary': '#8CB00E',
        'danger': '#C50015',
        'warning': '#F8B200',
      },
    },
  },
})

const pinia = createPinia()

interceptorsSetup()

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('app') !== null) {
    return new Vue({
      el: '#app',
      store,
      vuetify,
      pinia,
      data() {
        return {
          openSidebar: true,
          overlay: false,
          window: {
            width: 0,
          },
        }
      },
      created() {
        // eslint-disable-next-line
        this.openSidebar = window.innerWidth > 1000
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
      },
      methods: {
        handleResize() {
          this.window.width = window.innerWidth
          if (this.window.width <= 1000) {
            this.openSidebar = false
          } else {
            this.openSidebar = true
          }
        },
      },
    })
  }

  return null
})

